import React, { useRef } from 'react';
import BBCodeText from '../shared/BBCodeText';
import './BBCodeEditor.css';

const BBCodeEditor = ({ value, onChange, placeholder }) => {
  const textareaRef = useRef(null);

  const replaceSelection = (openTag, closeTag, fallback = '') => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selected = value.slice(start, end) || fallback;
    const nextValue = `${value.slice(0, start)}${openTag}${selected}${closeTag}${value.slice(end)}`;
    onChange(nextValue);

    requestAnimationFrame(() => {
      textarea.focus();
      textarea.setSelectionRange(start + openTag.length, start + openTag.length + selected.length);
    });
  };

  const insertList = (ordered) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selected = value.slice(start, end) || 'List item';
    const items = selected.split('\n').filter(Boolean).map(line => `[li]${line}[/li]`).join('\n');
    const tag = ordered ? 'ol' : 'ul';
    const replacement = `[${tag}]\n${items}\n[/${tag}]`;
    onChange(`${value.slice(0, start)}${replacement}${value.slice(end)}`);
  };

  const tools = [
    { label: 'B', title: 'Bold', action: () => replaceSelection('[b]', '[/b]', 'bold text') },
    { label: 'I', title: 'Italic', action: () => replaceSelection('[i]', '[/i]', 'italic text') },
    { label: 'U', title: 'Underline', action: () => replaceSelection('[u]', '[/u]', 'underlined text') },
    { label: 'S', title: 'Strikethrough', action: () => replaceSelection('[s]', '[/s]', 'strikethrough text') },
    { label: 'Link', title: 'Link', action: () => replaceSelection('[url=https://]', '[/url]', 'link text') },
    { label: 'List', title: 'Bulleted list', action: () => insertList(false) },
    { label: '1. List', title: 'Numbered list', action: () => insertList(true) },
    { label: 'Quote', title: 'Quote', action: () => replaceSelection('[quote]', '[/quote]', 'quoted text') }
  ];

  return (
    <div className="bbcode-editor">
      <div className="bbcode-toolbar" role="toolbar" aria-label="Description formatting">
        {tools.map(tool => (
          <button key={tool.title} type="button" title={tool.title} onClick={tool.action}>
            {tool.label}
          </button>
        ))}
      </div>
      <textarea
        ref={textareaRef}
        className="admin-form-textarea bbcode-textarea"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        rows="6"
        placeholder={placeholder}
      />
      <div className="bbcode-preview">
        <span>Preview</span>
        {value.trim() ? (
          <BBCodeText text={value} className="bbcode-preview-content" />
        ) : (
          <p className="bbcode-preview-empty">Formatted text will appear here.</p>
        )}
      </div>
    </div>
  );
};

export default BBCodeEditor;
